import { render, staticRenderFns } from "./share.vue?vue&type=template&id=1908147f&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=1908147f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908147f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/sit-app-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1908147f')) {
      api.createRecord('1908147f', component.options)
    } else {
      api.reload('1908147f', component.options)
    }
    module.hot.accept("./share.vue?vue&type=template&id=1908147f&scoped=true&", function () {
      api.rerender('1908147f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/share.vue"
export default component.exports